import {
  DialogContent,
  Button,
  DialogActions,
  DialogContentText,
  Dialog,
  DialogTitle,
} from '@mui/material';
import React, { useState } from 'react';
import HubSpotMeetingScript from './HubSpotMeetingScript';
import axiosInstance from 'utils/axios';
import useResponsive from 'hooks/useResponsive';
import { UPDATE_PROFILE_API_URL } from 'api/ApiConstants/GeneralConstants';

const GettingStartedModal = ({
  isAccountSetuped,
}: {
  isAccountSetuped: boolean;
}) => {
  const [step, setStep] = useState('1');
  const [selectedStep, setSelectedStep] = useState('1');
  const isDesktop = useResponsive('up', 'sm');

  async function updateProfle() {
    try {
      const respo = await axiosInstance.post(`${UPDATE_PROFILE_API_URL}`, {
        progress_settings: {
          postAccountSetup: true,
          Dashboard: false,
          'coupon-rule': false,
        },
      });
      if (respo.data.success) {
        window.location.reload();
      }
    } catch (error) {}
  }

  return (
    <Dialog
      open={!isAccountSetuped}
      onClose={() => {}}
      maxWidth={isDesktop ? 'md' : 'xs'}
      fullWidth
    >
      <DialogTitle style={{ fontSize: '24px' }} id='alert-dialog-title'>
        {'Getting Started'}
      </DialogTitle>
      <hr
        style={{
          height: '1px',
          backgroundColor: '#ddd',
          border: 'none',
          marginTop: '10px',
        }}
      />
      <DialogContent style={{ display: step === '1' ? 'block' : 'none' }}>
        <DialogContentText
          style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#212B36',
            marginTop: '-10px',
            textAlign: 'center',
          }}
        >
          Welcome to HubSpot Automated Coupons
        </DialogContentText>
        <DialogContentText
          id='alert-dialog-description'
          style={{ marginTop: '10px' }}
        >
          <p>
            Effortlessly generate <b>personalized coupon codes</b> using{' '}
            <b>HubSpot workflows</b>. Set your rules, automate discounts, and
            boost conversions—all within <b>HubSpot!</b>
          </p>
          <ul className='welcome-message' style={{ paddingLeft: '20px' }}>
            <li>Convert more with unique coupons</li>
            <li>Recover abandoned carts</li>
            <li>Reward loyal customers</li>
            <li>Sync coupon marketing with CRM data</li>
          </ul>
        </DialogContentText>
      </DialogContent>
      <DialogContent
        style={{
          display: step === '2' ? 'block' : 'none',
          maxHeight: '450px',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0 4px',
          }}
        >
          <DialogContentText
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: selectedStep === '1' ? '#fff' : '#212B36',
              marginTop: '-10px',
              textAlign: 'center',
              border: '1px solid',
              borderColor: selectedStep === '1' ? '#3881f7' : '#ddd',
              background: selectedStep === '1' ? '#3881f7' : 'transparent',
              padding: '5px',
              width: '49%',
              cursor: 'pointer',
            }}
            onClick={() => setSelectedStep('1')}
          >
            Let us set it up for you
          </DialogContentText>
          <DialogContentText
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: selectedStep === '2' ? '#fff' : '#212B36',
              marginTop: '-10px',
              textAlign: 'center',
              border: '1px solid',
              borderColor: selectedStep === '2' ? '#3881f7' : '#ddd',
              background: selectedStep === '2' ? '#3881f7' : 'transparent',
              padding: '5px',
              width: '49%',
              cursor: 'pointer',
            }}
            onClick={() => setSelectedStep('2')}
          >
            Do it yourself
          </DialogContentText>
        </div>
        <div style={{ display: selectedStep === '1' ? 'block' : 'none' }}>
          <HubSpotMeetingScript />
        </div>
        <div
          style={{
            display: selectedStep === '2' ? 'block' : 'none',
            marginTop: '10px',
          }}
        >
          <iframe
            width='100%'
            height='400'
            src='https://www.youtube.com/embed/O_GV7H8oH-0?si=9ueRZtA_hOAkzI6t'
            title='YouTube video player'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
          ></iframe>
        </div>
      </DialogContent>
      <DialogActions>
        {step === '1' ? (
          <>
            <Button
              onClick={() => {
                setStep('2');
              }}
            >
              Next
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={() => {
                updateProfle();
              }}
            >
              Finish
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default GettingStartedModal;
